import React, { useEffect } from 'react';
import { licitacionesPublicas } from '../../json/licitacionesPublicas2021';
import '../LicitacionesPublicas/licitacionesPublicas.css';


  const DetalleLicitacion2021 = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className="container">
        <div className="row">
              <div> 
                  <h3 className="title">Licitaciones Públicas 2021</h3>
                  <hr className="hr-gob" />
              </div>

         <div style={{ width: "100%" }}>
            <table className="table table-striped table-bordered">
                      <tr>
                        <th scope="col" colspan="2"><div className="detalle_nombreLicitacion" style={{ width: "460px" }}>Licitación Pública No.</div></th>
                        <th scope="col"><div style={{ width: "150px" }}>Convocatoria</div></th>
                        <th scope="col"><div style={{ width: "150px" }}>Bases</div></th>
                        <th scope="col"><div style={{ width: "150px" }}>Junta de aclaraciones</div></th>
                        <th scope="col"><div style={{ width: "150px" }}>Presentación y Apertura</div></th>
                        <th scope="col"><div style={{ width: "150px" }}>Fallo</div></th>
                      </tr>
            </table>
         </div>
            
            <div className="contenedor-tabla">
            <table className="table table-striped table-bordered tabla-elementos">
                    <tbody>
                       {
                        licitacionesPublicas.map((item, index)=>(
                          <tr key={ index }>
                              <th><div className="detalle_i"><i className="bi bi-file-earmark-pdf-fill"></i></div></th>
                              <th scope="row">
                                <div className="detalle_Licitacion"> { item.Nombre } </div>
                              </th>
                              <td>
                                <div className="div-elementos">
                                  {
                                    item.Convocatoria.map((iconvo, index2)=>(
                                    <a key={ index2 } href={ iconvo.linkConvocatoria } target="_blank" rel="noopener noreferrer"><button className='btn btn-default btn-pdf' type='button'> { iconvo.boton } </button></a> 
                                    ))
                                  }
                                </div>
                              </td>
                              <td>
                                <div className="div-elementos">
                                  {
                                    item.Bases.map((ibases, index3)=>(
                                    <a key={ index3 } href={ ibases.linkBases } target="_blank" rel="noopener noreferrer"><button className='btn btn-default btn-pdf' type='button'> { ibases.boton } </button></a>  
                                    ))
                                  }
                                </div>
                              </td>
                              <td>
                                <div className="div-elementos">
                                  {
                                    item.Aclaraciones.map((iaclar, index4)=>(
                                    <a key={ index4 } href={ iaclar.linkActaAclaraciones } target="_blank" rel="noopener noreferrer"><button className='btn btn-default btn-pdf' type='button'> { iaclar.boton } </button></a> 
                                    ))
                                  }
                                </div>
                              </td>
                              <td>
                                <div className="div-elementos">
                                  {
                                    item.Apertura.map((iapert, index5)=>(
                                    <a key={ index5 } href={ iapert.linkActaApertura } target="_blank" rel="noopener noreferrer"><button className='btn btn-default btn-pdf' type='button'> { iapert.boton } </button></a> 
                                    ))
                                  }
                                </div>
                              </td>
                              <td>
                                <div className="div-elementos">
                                  {
                                    item.Fallo.map((ifallo, index6)=>(
                                    <a key={ index6 } href={ ifallo.linkActaFallo } target="_blank" rel="noopener noreferrer"><button className='btn btn-default btn-pdf' type='button'> { ifallo.boton } </button></a> 
                                    ))
                                  }
                                </div>
                              </td>
                          </tr>
                        ))
                       }  
                  </tbody>
              </table>
          </div>         
       </div>
    </div>
    )
}

export default DetalleLicitacion2021